import { ProductListModel } from 'api-hooks/product/list';
import * as Yup from 'yup';

export const ProductVariantFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    sellPrice: Yup.number().default(0),
    description: Yup.string().default(''),
    stock: Yup.number().default(0),
    //additional information
    customId: Yup.string().default(''),
  });

export const ProductFormSchema = () =>
  Yup.object({
    code: Yup.string().default(''),
    name: Yup.string().default(''),
    description: Yup.string().default(''),
    productVariants: Yup.array(ProductVariantFormSchema()).default([]),
  });

export type ProductFormType = Yup.InferType<
  ReturnType<typeof ProductFormSchema>
> & {
  product?: ProductListModel;
};

export type ProductVariantFormType = Yup.InferType<
  ReturnType<typeof ProductVariantFormSchema>
>;
